import { useQuery } from '@provision/graphql-client';
import { GET_LEGAL_DOCUMENT_SEGMENT_TOKEN_QUERY } from 'src/graphql/entities/legal-document/legal-document.operations';

/** Only the backend holds the secret, so it hands out the token for a segment's public links. */
export const useLegalDocumentSegmentToken = (
  partnerId: number | null,
  brandId: string | undefined,
): string | null => {
  const { data } = useQuery<{ getLegalDocumentSegmentToken: string }>(
    GET_LEGAL_DOCUMENT_SEGMENT_TOKEN_QUERY,
    {
      skip: partnerId === null || !brandId,
      variables: { input: { partnerId, brandId } },
    },
  );

  return data?.getLegalDocumentSegmentToken ?? null;
};
